import { AUTH_ERROR, AUTH_SUCCESS } from '.'

const authReducer = (state, action) => {
  switch (action.type) {
    case AUTH_SUCCESS:
      return {
        ...state,
        isLoggedIn: true
      }
    case AUTH_ERROR:
      return {
        ...state,
        isLoggedIn: false
      }
    default:
      return state
  }
}

export { authReducer }
